// extracted by mini-css-extract-plugin
module.exports = {"Body":"richTextStyle_Body__2bluL"};